import styled from 'styled-components/macro';

export const P = styled.p`
  font-size: 16px;
  line-height: 22px;
  font-weight: 300;
`;

export default P;
